import type { MembershipBadge } from "../interfaces/rest-api";

const MEMBERSHIP_BADGE_META: Record<
  MembershipBadge,
  { label: string; className: string }
> = {
  subscriber: {
    label: "Subscriber",
    className: "border-blue-200 bg-blue-50 text-blue-700",
  },
  patron: {
    label: "Patron",
    className: "border-purple-200 bg-purple-50 text-purple-700",
  },
  premium: {
    label: "Premium",
    className: "border-amber-200 bg-amber-50 text-amber-700",
  },
};

export const getMembershipBadgeMeta = (badge?: MembershipBadge) => {
  const normalized: MembershipBadge =
    badge && MEMBERSHIP_BADGE_META[badge] ? badge : "subscriber";

  return {
    value: normalized,
    ...MEMBERSHIP_BADGE_META[normalized],
  };
};
